var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { I18nService } from '@/services/i18n-service';
import { inject, injectable } from 'inversify';
import { FieldPermissionDialogService, FieldPermissionDialogServiceSymbol } from '@/presentation/components/field-permission-dialog/FieldPermissionDialogService';
let FieldPermissionCommandContribution = class FieldPermissionCommandContribution {
    constructor(_i18nService, _fieldPermissionDialogService) {
        this._i18nService = _i18nService;
        this._fieldPermissionDialogService = _fieldPermissionDialogService;
    }
    registerCommands(commands) {
        commands.registerCommand({
            id: 'custom-field.permission-setting',
            icon: 'SolidSettings',
            label: this._i18nService.t('customField.actions.advancedPermissionSetting'),
        }, {
            execute: (context) => {
                return this._openPermissionDialog(context);
            },
        });
    }
    _openPermissionDialog(context) {
        // 从context中获取字段信息
        if (!context.fields || context.fields.length === 0) {
            console.warn('FieldPermissionDialog: context.fields is empty');
            return;
        }
        // 获取第一个字段的ID
        const field = context.fields[0];
        const fieldId = field.field_id;
        // 使用弹窗服务打开弹窗，只传递字段ID
        this._fieldPermissionDialogService.open(fieldId);
    }
};
FieldPermissionCommandContribution = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __param(1, inject(FieldPermissionDialogServiceSymbol)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object, typeof (_b = typeof FieldPermissionDialogService !== "undefined" && FieldPermissionDialogService) === "function" ? _b : Object])
], FieldPermissionCommandContribution);
export { FieldPermissionCommandContribution };
